import { ScrollObserver } from './libs/scroll';
import { MobileNav } from './libs/mobile-nav';
import { FotterAcodion } from './libs/fotterAcodion';
import { HeaderMove } from './libs/HeaderMove';

document.addEventListener('DOMContentLoaded', function () {
  const mobileNav = new MobileNav();
  const footerAcodion = new FotterAcodion();
  const headerMove = new HeaderMove();
});
